import { useState } from "react";
import "../Assets/Style/HomeHeader.scss";
import Button from "./Button";
import logo from "../Assets/Img/zeelogo.png";
import { Link } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="Home_Header">
      <div className="Inner_Container">
        <Link to="/">
          <img src={logo} alt="avatar" />
        </Link>
        <AiOutlineMenu className="MenuIcon" onClick={() => setIsOpen(true)} />
        <div className="Header_Link_Contain">
          <Link to="/" className="Header_Link">
            HOME
          </Link>
          <Link to="/get-rates" className="Header_Link">
            OUR RATES
          </Link>
          <Link to="/track-ship" className="Header_Link">
            TRACK
          </Link>
          <Link to="/contact-us" className="Header_Link">
            CONTACT US
          </Link>
          <Link to="/login" className="Start_Btn">
            <Button color="#E92D38" text="GET STARTED" width="8.69rem" />
          </Link>
        </div>
      </div>

      {/* Mobile side panel */}
      <div className={`Side_Panel_Overlay${isOpen ? " open" : ""}`} onClick={() => setIsOpen(false)} />
      <div className={`Side_Panel${isOpen ? " open" : ""}`}>
        <div className="Side_Panel_Header">
          <Link to="/" onClick={() => setIsOpen(false)}>
            <img src={logo} alt="avatar" />
          </Link>
          <AiOutlineClose className="CloseIcon" onClick={() => setIsOpen(false)} />
        </div>
        <nav className="Side_Panel_Links">
          <Link to="/" className="Side_Link" onClick={() => setIsOpen(false)}>HOME</Link>
          <Link to="/get-rates" className="Side_Link" onClick={() => setIsOpen(false)}>OUR RATES</Link>
          <Link to="/track-ship" className="Side_Link" onClick={() => setIsOpen(false)}>TRACK</Link>
          <Link to="/contact-us" className="Side_Link" onClick={() => setIsOpen(false)}>CONTACT US</Link>
          <Link to="/login" className="Side_Btn" onClick={() => setIsOpen(false)}>
            <Button color="#E92D38" text="GET STARTED" width="100%" />
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default Header;
